import { baseSepolia, optimismSepolia, sepolia } from 'viem/chains';

import type { ConfigEntry } from './config.types';

export const config: ConfigEntry = {
  environmentName: 'dev',
  chains: [sepolia, optimismSepolia, baseSepolia],
  baseUrls: {
    app: 'https://app.dev.endaoment.org',
    marketing: 'https://mktg.dev.endaoment.org',
    blog: 'https://blog.endaoment.org', // No dev blog in Vercel, point to prod
    api: 'https://api.dev.endaoment.org',
    docs: 'https://docs.endaoment.org',
    oauth: 'https://oauth.dev.endaoment.org',
    miniApp: 'https://endaoment-mini-app-test.vercel.app',
    overview: 'https://impact.dev.endaoment.org',
  },
  socialLoginChainId: optimismSepolia.id,
  zeroDev: {
    projectId: 'bcba09cd-0884-43c3-98f4-128ebf84572f',
    // We are sponsoring dev transactions ourselves! This was a workaround when ZD's paymaster started crapping out for
    // project bcba09cd-0884-43c3-98f4-128ebf84572f specifically. In case you see issues with user ops / AA transactions,
    // verify if our paymaster wallet is properly funded
    // https://dashboard.zerodev.app/projects/self-funded-paymasters
    bundlerRpcUrl: 'https://rpc.zerodev.app/api/v3/bcba09cd-0884-43c3-98f4-128ebf84572f/chain/11155420',
    paymasterRpcUrl:
      'https://rpc.zerodev.app/api/v3/bcba09cd-0884-43c3-98f4-128ebf84572f/chain/11155420?selfFunded=true',
  },
  privyAppId: 'clv19o5jv06nxtjte9ecj88o0',
  googleMapsApiKey: 'AIzaSyBNX_ixICIxKEUHNiWFGdBBbi42OD4GN7k',
  mapboxApiKey: 'pk.eyJ1IjoiZW5kYW9tZW50IiwiYSI6ImNsaGo5MDRmdzBmZXozZnBiMHV1NWRjcGIifQ.HfvViRsi4sKeYxFYt7-BQw',
  identifiersSecret: '0c8b1114-b048-4f6b-b33e-7ed296442555f5e1d732-6a0c-468e-9c3e-e8ce37e4e56e',
};
